import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { getProductBySlug, deleteProduct } from "../api/products";
import { isLoggedIn } from "../api/auth";
import { formatPrice } from "../utils/format";
import { addItem } from "../cart/cart";
import * as Toast from "@radix-ui/react-toast";
import ContactModal from "../components/ContactModal";

function ProductDetailPage() {
    var params = useParams();
    var slug = params.slug;
    var navigate = useNavigate();

    var [product, setProduct] = useState(null);
    var [loading, setLoading] = useState(true);
    var [error, setError] = useState(null);
    var [deleting, setDeleting] = useState(false);
    var [contactOpen, setContactOpen] = useState(false);

    useEffect(function () {
        setLoading(true);
        setError(null);
        getProductBySlug(slug)
            .then(function (data) { setProduct(data); })
            .catch(function (err) { setError(err.message); })
            .finally(function () { setLoading(false); });
    }, [slug]);

    function handleDelete() {
        if (!isLoggedIn() || !product || product.id == null) { return; }
        var ok = window.confirm("Naozaj chceš zmazať tento produkt?");
        if (!ok) { return; }
        setDeleting(true);
        deleteProduct(product.id)
            .then(function () { navigate("/ponuka"); })
            .catch(function (err) { alert("Mazanie zlyhalo: " + (err.message || "")); })
            .finally(function () { setDeleting(false); });
    }

    function handleImageError(e) { e.currentTarget.src = "/images/hodiny3.png"; }

    const [toastOpen, setToastOpen] = useState(false);

    function handleAddToCart() {
        if (!product) return;
        if (product.quantity < 1){
            alert("Tento produkt momentálne nie je skladom.");
            return;
        }
        addItem(product, 1);
        // re-trigger toast
        setToastOpen(false);
        setTimeout(() => setToastOpen(true), 0);
    }

    function openModal() { setContactOpen(true); }
    function closeModal() { setContactOpen(false); }

    if (loading) { return <div className="container py-4">Načítavam produkt…</div>; }
    if (error)   { return <div className="container py-4 text-danger">Chyba: {error}</div>; }
    if (!product){ return <div className="container py-4">Produkt sa nenašiel.</div>; }

    // var img = toImageSrc(product.imageUrl || product.image);
    var img = product.imageUrl || product.image;

    return (
        <Toast.Provider swipeDirection="right" duration={2000}>
            <div className="container py-4">
                <Link to="/ponuka" className="btn btn-outline-secondary mb-3 rounded-pill">← späť na ponuku</Link>

                <div className="row g-4">
                    <div className="col-md-6">
                        <img
                            src={img}
                            alt={product.name}
                            className="img-fluid rounded"
                            onError={handleImageError}
                            style={{ objectFit: "cover", width: "100%" }}
                        />
                    </div>

                    <div className="col-md-6">
                        <h1 className="h3 mb-2">{product.name}</h1>
                        {product.category &&
                            <div className="text-muted mb-2"> {product.category}
                                {product.subcategory &&
                                    <span> > {product.subcategory}
                                    </span>}
                            </div>}
                        <ul className="list-unstyled small mb-3">
                            {product.size && (
                                <li className="mb-1">
                                    <span className="text-muted">Veľkosť: </span>
                                    <span className="fw-semibold">{product.size}</span>
                                </li>
                            )}
                            {product.wood && (
                                <li className="mb-1">
                                    <span className="text-muted">Drevo: </span>
                                    <span className="fw-semibold">{product.wood}</span>
                                </li>
                            )}
                        </ul>

                        <p className="text-muted" style={{ whiteSpace: "pre-line"}}>{product.description}</p>

                        <div className="fs-4 fw-bold mb-3">{formatPrice(product.price)}</div>

                        <div className="d-flex align-items-center gap-3 my-3">
                            <button type="button" className="btn btn-brown rounded-pill px-4" onClick={openModal}>
                                Mám záujem
                            </button>
                            {isLoggedIn() && (
                                <button type="button" className="btn btn-outline-danger" onClick={handleDelete} disabled={deleting}>
                                    {deleting ? "Mažem…" : "Zmazať"}
                                </button>
                            )}
                            {isLoggedIn() && (
                                <button type="button" className="btn btn-outline-warning">
                                    <Link to={"/admin/produkt/" + product.id + "/upravit"} className="text-decoration-none text-dark">Upraviť</Link>
                                </button>
                            )}
                        </div>

                        {product.quantity != null && <div className="text-secondary">Skladom: {product.quantity} ks</div>}

                    </div>
                </div>
            </div>
            <ContactModal show={contactOpen} onHide={closeModal} product={product} slug={slug} />
            <Toast.Root open={toastOpen} onOpenChange={setToastOpen} className="rt-toast">
                <Toast.Title className="rt-title">Pridané do košíka</Toast.Title>
                <Toast.Description className="rt-desc">
                    {product?.name} bol pridaný.
                </Toast.Description>
            </Toast.Root>

            <Toast.Viewport className="rt-viewport" />
        </Toast.Provider>
    );
}

export default ProductDetailPage;
